import { SVGProps } from 'react';
import { motion, useAnimate, SVGMotionProps } from 'framer-motion';
import { useEffect } from 'react';

interface RefreshIconProps
  extends Omit<SVGMotionProps<SVGSVGElement>, keyof SVGProps<SVGSVGElement>> {
  isRefreshing?: boolean;
  className?: string;
  'aria-hidden'?: boolean;
}

export function RefreshIcon({
  className = '',
  'aria-hidden': ariaHidden = true,
  isRefreshing = false,
  ...props
}: RefreshIconProps) {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    if (isRefreshing) {
      // Start continuous rotation
      animate(
        scope.current,
        { rotate: [0, 360] },
        {
          duration: 1,
          ease: 'linear',
          repeat: Infinity,
        },
      );
    } else {
      // Complete the current rotation and stop
      animate(
        scope.current,
        { rotate: 360 },
        {
          duration: 1,
          ease: 'linear',
        },
      );
    }
  }, [isRefreshing, animate]);

  return (
    <motion.svg
      ref={scope}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={className}
      aria-hidden={ariaHidden}
      initial={{ rotate: 0 }}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 4v5h-.582M4.062 11A8.001 8.001 0 0119.418 9M19.418 9H15m-11 11v-5h.581m0 0a8.003 8.003 0 0015.357-2M4.581 15H9"
      />
    </motion.svg>
  );
}
